import _ from "lodash";

export const mapListToSelectOptions = (list) =>
    list.map((item) => ({
        value: item,
        text: _.startCase(item),
    }));

export const mapTripPointsToEntity = (tripPoints, pickupDateAndTime) =>
    tripPoints.map((point, i) => ({
        cityId: point.city.id,
        locationId: point.location.id,
        pointType: "dropoff",
        position: i + 2,
        locationCategoryId: point.category.id,
    }));

export const mapTripsToEntity = (trips) =>
    trips.map((trip) => ({
        supplierId: trip.supplier && trip.supplier.value ? +trip.supplier.value : null,
        supplierContractType:
            trip.supplierContractType && trip.supplierContractType.value
                ? +trip.supplierContractType.value
                : null,
        driverId: trip.driver && trip.driver.value ? +trip.driver.value : null,
        truckId: trip.truck && trip.truck.value ? +trip.truck.value : null,
        truckTypeId: trip.truckType && trip.truckType.value ? +trip.truckType.value : null,
        pickupTime: trip.pickupDateAndTime,
        tripPoints:
            trip.tripPoints && mapTripPointsToEntity(trip.tripPoints, trip.pickupDateAndTime),
        tripAttachments: trip.tripAttachments.map((a) => ({ url: a.value })),
        notes: trip.tripNotes,
        returnable: trip.returnable,
        tripTypeId: trip.tripType && trip.tripType.value ? +trip.tripType.value : null,
    }));

export const mapOrderToEntityRequest = (
    organization,
    branch,
    contractType,
    isSourceApp,
    requestDate,
    orderProject,
    trips
) => ({
    data: {
        type: "orders",
        attributes: {
            organizationId: +organization.value,
            branchId: +branch.value,
            contractType: contractType.value,
            source: isSourceApp ? 0 : 2,
            requestedAt: requestDate ? requestDate.locale("en").format() : null,
            projectId: +orderProject?.value,
            trips: mapTripsToEntity(trips),
        },
    },
});

/**
 * Get trip ids of order object
 * @param {object} order
 * @returns {array} trip ids array or null
 */
export const getTripIds = (order) =>
    _.values(order["entities"]["orders"])[0]["attributes"]["tripIds"] || null;

// validation utils
export const isTripPointsValid = (tripPoints, tripTypeAttributes) => true;

export const isTripValid = (trip) => {
    if (_.isNil(trip)) {
        return false;
    }

    const { pickupDateAndTime, tripPoints } = trip;
    return tripPoints.length
        ? !!(pickupDateAndTime && isTripPointsValid(tripPoints))
        : !!pickupDateAndTime;
};

export const isOrderValid = (organization, trips) =>
    !!organization && !!organization.value && trips.every(isTripValid);

export const ReplaceMentionedUser = (string, users) => {
    const newArray = string.split(" ");
    newArray.map((item) => {
        const user = users.find((object) => item.replace("@__", "") === object.id);
        if (user) {
            newArray[newArray.map((x, i) => [i, x]).filter((x) => x[1] === item)[0][0]] =
                user["attributes"].firstName !== null
                    ? `${user["attributes"].firstName} ${user["attributes"].lastName}`
                    : user["attributes"].email;
        }
    });
    return newArray.join(" ");
};
